import { FC } from "react";
import { Link, X } from "lucide-react";

import { CategoryTreeObject } from "@vviinn/user-managment-client-ts";
import { SMALL_ICON_SIZE_STYLES } from "../../../../../ui/styles";
import { Button } from "../../../../../ui/layout/molecules/Button";

type CategoryItemProps = {
  category: CategoryTreeObject;
  isAssigned: boolean;
  onCategoryClick?: () => void;
  onLinkClick?: () => void;
  onUnlinkClick?: () => void;
};

export const CategoryItem: FC<React.PropsWithChildren<CategoryItemProps>> = ({
  category,
  isAssigned,
  onCategoryClick,
  onLinkClick,
  onUnlinkClick,
}) => {
  return (
    <div className="grid grid-cols-[1fr_36px] items-center gap-2 py-2 *:truncate *:text-sm">
      <div onClick={onCategoryClick} className="cursor-pointer ">
        <span className="inline-flex items-center truncate text-sm text-stone-900 dark:text-white">
          {category.title}
          {isAssigned && (
            <span
              className={`ml-[3px] inline-flex items-center justify-center rounded-full bg-stone-500 dark:bg-stone-700 ${SMALL_ICON_SIZE_STYLES}`}
            >
              <Link className="h-3 w-3 text-white dark:text-stone-400" />
            </span>
          )}
        </span>
        <p className="text-xs text-stone-400 dark:text-stone-300">
          {category.tree.length} subcategories
        </p>
      </div>
      <Button
        title={isAssigned ? "unlink" : "link"}
        onClick={isAssigned ? onUnlinkClick : onLinkClick}
        buttonType="iconOnly"
        className="align-center flex p-1.5 h-9 w-9 items-center rounded-full bg-stone-100 text-center text-stone-400 hover:bg-stone-200 hover:text-stone-500 dark:bg-stone-900 dark:text-stone-500 dark:hover:bg-stone-950 dark:hover:text-stone-400"
      >
        {isAssigned ? (
          <X className={SMALL_ICON_SIZE_STYLES} />
        ) : (
          <Link className={SMALL_ICON_SIZE_STYLES} />
        )}
      </Button>
    </div>
  );
};
